/** Replace space in email input */
export const EMAIL_INPUT_FILTER_REPLACE_REGEX = /\s/g

const EMAIL_REGEX = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@"]{2,})$/i
export const isEmail = (email: string) => EMAIL_REGEX.test(email)

/** 過濾 email 輸入，移除空白字元 */
export const filterEmail = (value: string) =>
  value.replace(EMAIL_INPUT_FILTER_REPLACE_REGEX, '')
